var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.28 74.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #110bff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.42 19.96 2.36 48.81 0 57.91 3.42 69.3 6.6 57.91 3.81 48.74 3.42 19.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.79,51.76l-37.56-17.13v18.85q.15,1.56.15,2.29c0,6.7,6.26,18.72,37.41,18.72s36.03-10.8,36.03-17.5q0-.69.13-4l-.06-18.37-36.09,17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,19.96c-1.71,0-3.23-.3-4.21-.83H3.3l56.49,25.51,56.49-26.63L59.1,0,5.35,17.12h48.42c.64-.93,2.74-1.61,5.23-1.61,2.99,0,5.38.98,5.38,2.21s-2.39,2.25-5.38,2.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.c5578bce85799761d6c55507abd4b7f8.svg";
export { ForwardRef as ReactComponent };